import { render, staticRenderFns } from "./LicenseExpiredModal.vue?vue&type=template&id=d72a0536&scoped=true"
import script from "./LicenseExpiredModal.vue?vue&type=script&lang=js"
export * from "./LicenseExpiredModal.vue?vue&type=script&lang=js"
import style0 from "./LicenseExpiredModal.vue?vue&type=style&index=0&id=d72a0536&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a0536",
  null
  
)

export default component.exports